namespace SP {
    export interface ToteItem {
        qty: number;
        orderLineId: string;
        itemInfo: ItemInfo;
    }
}